module.exports = __webpack_public_path__ + "static/media/remark.d2afa010.png";